function isScrolledIntoView(elem) {
  var $ = jQuery;

  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = $(elem).offset().top + $(elem).height() -  ($(window).height() / 4);

  return (elemBottom <= docViewBottom);
  // return (elemTop >= docViewTop);
}

function isInViewport(node) {
  var rect = node.getBoundingClientRect()
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

// function parallaxScroll(elem) {
//   var $ = jQuery;
//   var scrolled = $(window).scrollTop()
//    $(elem).each(function(index, element) {
//      var initY = $(this).offset().top
//      var height = $(this).height()
//      var endY  = initY + $(this).height()
//
//      var $pImg = $(this).find('.wp-block-image').find('img');
//
//      // Check if the element is in the viewport.
//      if(isInViewport(this)) {
//        var diff = scrolled - initY
//        var ratio = Math.round((diff / height) * 100)
//        $pImg.css('transform','translate(-50%, ' + parseInt((ratio * .25)) + 'px)')
//      }
//    });
// }

// Smooth scroll for anchor links
jQuery(document).on('click', 'a[href*="#"]:not(.noscroll)', function (event) {

  var $ = jQuery;

  var pagePath = window.location.pathname,
      linkPath = $.attr(this, 'href').substring(0, $.attr(this, 'href').indexOf("#"));
      elementID = $.attr(this, 'href').substring($.attr(this, 'href').indexOf("#"));

  // console.log(pagePath, linkPath, linkPath.length);

  if( (pagePath === linkPath || linkPath.length === 0) && elementID.length > 1) {
    event.preventDefault();

    if($(elementID).length) {
      $('html, body').animate({
          scrollTop: $(elementID).offset().top
      }, 500);
    }
  }
});


jQuery(document).ready(function($) {
  $('.addNextButton').each(function() {
    var $nextButton = $('<button class="nextSection"><span>Next Section</span></button>');
    var $nextElement = $(this).next();

    if($(this).find('.wp-block-cover__inner-container').length) {
      $(this).find('.wp-block-cover__inner-container').append($nextButton);
    } else {
      $(this).append($nextButton);
    }


    $nextButton.click(function() {
      $('html, body').animate({
        scrollTop: $nextElement.offset().top
      }, 500);

    });
  });

  $('#backToTop').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  });
});
